var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.numberOfItems)?_c('small',{staticClass:"fw7 c6 fs3"},[_vm._v("\n\t"+_vm._s(_vm.pageInfo)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }